<div id="loading" *ngIf="sharedService.loading"><img src="/assets/images/loading.gif"></div>